import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { IncomeService, IncomeData, IncomedBill, IncomeBill, Income } from '../../services/income.service';
import { CustomerBillService, CustomerBillData, PrForBill, CreditNote, Incomed, CustomerBill, CustomerBillId } from '../../services/customer-bill.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { BankService, BankData } from '../../services/bank.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { EmployeeService, EmployeeId } from '../../services/employee.service';

@Component({
  selector: 'app-update-income',
  templateUrl: './update-income.component.html',
  styleUrls: ['./update-income.component.css']
})
export class UpdateIncomeComponent implements OnInit, OnDestroy {
  billId: string = '';

  incomeId: string;
  customerId: string;
  customerName: string = '';
  fiscalDataId: string;
  fiscalDataName: string = '';

  form: FormGroup;
  payMethodSelect: any[];

  pickadateParams = Utils.pickadateParams();

  subs = [];

  constructor(
    private service: IncomeService,
    private incomeData: IncomeData,
    private customerBillService: CustomerBillService,
    private customerBillData: CustomerBillData,
    private customerService: CustomerSupplierService,
		private fiscalDataService: FiscalDataService,
    private bankService: BankService,
    private bankData: BankData,
    private empService: EmployeeService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.incomeId = activatedRoute.snapshot.paramMap.get('id');
    this.customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    this.fiscalDataId = this.activatedRoute.snapshot.paramMap.get('fiscalDataId');

    console.log(localStorage.billReturnIncome)
    let {billReturnIncome: billId = ''} = localStorage;
    if(billId){
      delete localStorage.billReturnIncome;
      this.billId = billId;
    }

    this.payMethodSelect = Object.keys(incomeData.statusObjects).map(key => ({value: key, ...incomeData.statusObjects[key]}) );

    this.subs.push(
      this.customerService.getCustomerSupplier(this.customerId).subscribe(c => { this.customerName = c.name })
    );
    this.subs.push(
      this.fiscalDataService.getFiscalData(this.fiscalDataId).subscribe(fd => { this.fiscalDataName = fd.businessName })
    );

    this.banks = {};
    this.subs.push(
      this.bankService.getBanks().subscribe(banks => {
        this.rowsRead[0] = banks.filter(bank => {
          bank.name = bank.accountNumber;
          bank.currency = this.bankData.currencies[bank.currency].fullName;
          this.banks[bank.id] = {...bank};
          if(bank.isIncome) return bank;
        });
      })
    );
    this.emps = {};
    this.subs.push(
      this.empService.getEmployees().subscribe((employees: EmployeeId[]) => {
        this.rowsRead[1] = employees.map(employee => {
          employee.name += ` ${employee.lastName}`;
          this.emps[employee.id] = employee;
          return employee;
        });
      })
    );

    let billSub = this.customerBillService.getCustomerBills({customerId: this.customerId}).subscribe(customerBills => {
      billSub.unsubscribe();
      customerBills = Utils.sort(customerBills, [{key: 'folio', desc: false}])
      this.incomedBills = customerBills.filter(customerBill => {
        return (
          customerBill.status < 'key90' &&
          !!customerBill.totals.total &&
          customerBill.fiscalDataRef.id == this.fiscalDataId
        );
      }).map(customerBill => {
        let obj = new IncomedBill(customerBill, this.incomeId);
        if(!(obj.isComplete && !obj.lastAmount)) return obj;
      }).filter(t=>t);
    })
    /* this.subs.push(
    ); */
  }

  ngOnInit() {
    this.createForm();
    this.subs.push(
      this.service.getIncome(this.incomeId).subscribe(([{employeeObj, ...income}]) => {
        this.form.patchValue(income);
        this.selectedBankId = income.bankObj.id;
        this.selectedEmpId = employeeObj ? employeeObj.id : '';
      })
    );
  }
	ngOnDestroy() {
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm(){
    this.form = this.fb.group({
      folio: ['', Validators.required],
      date: ['', Validators.required],
      amount: [0, [Validators.required, Validators.min(0)]],
      extraAmount: [0, [Validators.required, Validators.min(0)]],
      payMethod: [this.payMethodSelect[0].value, Validators.required],
      reference: '',
      notes: ''
    });
  }

  onSubmit({ value, valid }: { value: any, valid: any }){

    value.amount = +value.amount.toFixed(4);
    value.extraAmount = +value.extraAmount.toFixed(4);
    value.customerRef = this.customerId;
    value.fiscalDataRef = this.fiscalDataId;
    value.bankRef = this.selectedBankId;
    value.employeeRef = this.selectedEmpId;
    value.bills = this.incomedBills.filter(bill => !!bill.amount).map(incomedBill => incomedBill.databaseObject);
    
    this.service.updateIncome(this.incomeId, value);
    this.updateCustomerBills();
    this.service.windowReplace(!this.billId ? 'read' : 'billView', this.billId);
  }
  
  updateCustomerBills(){
    let incomeRef = this.customerBillService.afhService.doc(`${this.service.collection}/${this.incomeId}`).ref;
    this.incomedBills.map(({customerBill, amount=0, extraAmount=0}) => {
      customerBill.incomeds = customerBill.incomeds.filter(incomed => incomed.incomeRef.id != this.incomeId);
      if(amount) customerBill.incomeds.push({incomeRef, amount, extraAmount});
      this.customerBillService.updateByField({incomeds: customerBill.incomeds}, customerBill.id);
    });
  }


  stringifyDate(date: Date){
    var dd:string = date.getDate() + '';
    var mm:string = date.getMonth()+ 1 + '';
    var yyyy = date.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  money = Utils.money;

  get today(){
    return this.stringifyDate(new Date());
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  get readValid(){ return this.selectedBankId };
  
  //Bank
  banks: any = {};
  selectedBankId: string = '';
  //Emp
  emps: {[s: string]: EmployeeId} = {};
  selectedEmpId: string = '';

  currentReadIndex: number;
  rowsRead = [[], []];
  columnsRead = [
    [//bank
      { title: 'Número de cuenta', name: 'name' },
      { title: 'Banco', name: 'bankName' },
      { title: 'CLABE', name: 'CLABE' },
      { title: 'Moneda', name: 'currency' }
    ],
    [//Emp
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Nombre', name: 'name' },
      { title: 'Correo electrónico', name: 'email' },
    ],
  ]

  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}): any{
    if(this.currentReadIndex == 0) this.selectedBankId = row.id;
    if(this.currentReadIndex == 1) this.selectedEmpId = row.id;
    this.closeModalRead();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

  //////////////////////////////////////////////////////////////////////////////////////////////CUSTOMER BILL
  incomedBills: IncomedBill[] = [];
  get incomedBillsTotal(): number {
    return this.incomedBills.reduce((total, incomedBill) => total + (incomedBill.amount || 0), 0);
  }
  get incomedBillsExtraTotal(): number {
    return this.incomedBills.reduce((total, incomedBill) => total + (incomedBill.extraAmount || 0), 0);
  }
  get incomedBillsTotalIsValid(): boolean {
    return !!(
      (Math.floor(this.incomedBillsTotal) == Math.floor(this.form.get('amount').value)) &&
      (!this.incomedBillsExtraTotal || Math.floor(this.incomedBillsExtraTotal) == Math.floor(this.form.get('extraAmount').value))
    );
  }
  get allIncomeBillsValid(): boolean {
    return this.incomedBills.find(bill => !bill.isValid) == undefined;
  }
  //////////////////////////////////////////////////////////////////////////////////////////////CUSTOMER BILL

  /* log(){
    console.log(this.form.valid, this.readValid, this.incomedBillsTotalIsValid, this.allIncomeBillsValid);
  } */
}